export default "__VITE_ASSET__KymDf_Si__"